var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container"},[_c('el-card',[_c('h3',[_vm._v("订单汇总页")])]),_c('br'),_c(_vm.currentRole,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }